<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 60px;
  color: #014492;
  font-weight: 550;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 34px;
  color: #014492;
}
.container10 .a{
  width: 1100px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.order-lists{
  margin-top: 20px;
  counter-reset: list-counter; /* 设置一个计数器 */
  list-style: none; /* 移除默认的列表样式 */
  padding-left: 0; /* 移除默认的内边距 */
  li {
    &::before{
      counter-increment: list-counter;
      content: counter(list-counter) ". "; /* 使用计数器的值作为前缀，并添加一个点 */
      font-weight: normal; /* 加粗数字 */
    }
  }
}
.service-details-table{
  width: 100%;
  border-left: 1px solid #E4E6EA;
  border-top: 1px solid #E4E6EA;
  tr{
    th{
      padding: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      background: #F6FAFD;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
    td{
      padding: 20px;
      padding-left: 30px;
      padding-right: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      text-align: center;
    }
  }
}
.table-tip{
  margin-top: 20px;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>假病毒</h1>
      <h2 class="mt10">Pseudovirus</h2>
      <div class="a"><span></span></div>
    </div>
    <section style="padding-top: 0">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">
          假病毒（pseudovirus）是一类特殊的病毒颗粒，具有与真病毒相似的部分特性，但由于缺乏完整的病毒基因组，无法复制和产生子代病毒。假病毒常用于研究病毒的感染机制、受体识别、病毒抑制，以及评估抗体和疫苗的效果。在基因编辑和病毒学研究中，假病毒因其独特的安全性和实验可控性被广泛应用。它们能够模拟真病毒的感染过程，却不会引发疾病，降低了生物安全风险。这使假病毒成为研究病毒与宿主细胞相互作用的有效工具。
        </p>
        <p class="desc" style="margin-bottom: 20px;">
          假病毒通常通过将特定病毒的表面蛋白（如 HIV 的 env 蛋白或冠状病毒的 S 蛋白）与不具复制能力的病毒载体（如慢病毒或水泡性口炎病毒 VSV）结合生成。这类假病毒可以感染宿主细胞，但不会在细胞内复制或生成新的病毒颗粒。
        </p>
        <p class="desc" style="margin-bottom: 20px;">
          假病毒的具体应用根据实验目的不同可以分为核酸检测假病毒和功能检测假病毒。核酸检测假病毒用于核酸检测的实验和质量控制，保留病毒部分基因序列，常用于 PCR 或 RT-PCR 等核酸检测方法的验证。它作为阳性对照或内控标准品，提高检测的准确性，确保检测试剂盒对特定病毒核酸的敏感性和特异性。
        </p>
        <p class="desc" style="margin-bottom: 20px;">
          功能检测假病毒则保留病毒的感染蛋白，但去除了复制和致病能力，主要用于研究病毒入侵机制、抗体中和能力测试及抗病毒药物筛选。此类假病毒通常携带报告基因，通过观察其表达，评估病毒感染效率、抗体中和作用及疫苗的免疫效果。
        </p>
        <p class="desc">	假病毒在病毒学研究中的主要应用包括：</p>
        <div class="desc">
          <ol class="order-lists">
            <li>
              病毒受体研究：用于确定病毒进入宿主细胞的特定受体。
            </li>
            <li>
              中和抗体检测：功能检测假病毒用于评估抗体对病毒的中和作用。
            </li>
            <li>
              疫苗开发：帮助测试疫苗所诱导的免疫反应，确保疫苗在体外实验中的有效性。
            </li>
            <li>
              药物筛选：功能检测假病毒用于筛选和评估抗病毒药物的效果。
            </li>
            <li>
              标准品：核酸检测假病毒作为核酸检测试剂盒中的阳性对照或内控标准品，确保检测结果的准确性。
            </li>
          </ol>
        </div>
      </div>
      <div class="c-title">服务内容<small>Service Details</small></div>
      <div class="container">
        <table class="service-details-table" cellpadding="0" cellspacing="0">
          <tr>
            <th>产品大类</th>
            <th>产品名称</th>
            <th>规格</th>
            <th>周期（工作日*）</th>
          </tr>
          <tr>
            <td rowspan="5">核酸检测假病毒</td>
            <td>RNA 假病毒定制</td>
            <td>拷贝数：>1×10⁸ GC/mL,1 mL</td>
            <td>15-18</td>
          </tr>
          <tr>
            <td>RNA 假病毒定制</td>
            <td>拷贝数：>1×10⁸ GC/mL,3 mL</td>
            <td>15-18</td>
          </tr>
          <tr>
            <td>DNA 假病毒定制</td>
            <td>拷贝数：>1×10⁹ GC/mL,1 mL</td>
            <td>15-18</td>
          </tr>
          <tr>
            <td>DNA 假病毒定制</td>
            <td>拷贝数：>1×10⁹ GC/mL,3 mL</td>
            <td>15-18</td>
          </tr>
          <tr>
            <td>现货假病毒</td>
            <td>拷贝数：>1×10⁸ GC/mL,1 mL</td>
            <td>15-18</td>
          </tr>
          <tr>
            <td rowspan="2">功能检测假病毒</td>
            <td>RNA 假病毒定制</td>
            <td>滴度：>1×10⁷ TU/mL,1 mL</td>
            <td>14</td>
          </tr>
          <tr>
            <td>DNA 假病毒定制</td>
            <td>滴度：>1×10⁷ TU/mL,1 mL</td>
            <td>14</td>
          </tr>
        </table>
        <p class="table-tip">*不包含质粒构建周期。</p>
      </div>
      <div class="c-title">服务流程<small>Service Process</small></div>
      <div class="container">
        <div style="margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/Virus/Virus/service-process.png" class="img-fluid"></div>
      </div>

      <div class="container">
        <qk-consult type="Virus3"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components: {
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Pseudovirus.vue